<template>
  <div
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    data-backdrop="static"
    class="modal fade"
    id="audio_preview"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            data-dismiss="modal"
            aria-label="Close"
            class="close"
            type="button"
          >
            <i class="iconfont icon-close"></i>
          </button>
          <h5 class="modal-title" id="myModalLabel">
            正在播放：{{ detail.name }}.{{ detail.file_ext }}
          </h5>
        </div>
        <div class="modal-body">
          <audio
            ref="audio"
            class="audio"
            autoplay
            :src="preview_path"
            controls="controls"
          >
            您的浏览器不支持 audio 标签。
          </audio>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { preview } from "@/api/drive/drive";
import { sharePreview, linkTargetPreview } from "@/api/share/share";
export default {
  name: "audioPreview",
  props: {
    detail: {
      type: Object,
    },
    linkShareNumber: {
      type: String,
    },
  },
  data() {
    return {
      preview_path: "",
      category: "",
      is_preview: "",
    };
  },
  computed: {
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    shareNumber() {
      return this.$store.state.drive.share.share_number;
    },
  },
  methods: {
    // 发布预览
    sendPreview() {
      linkTargetPreview({
        link_number: this.linkShareNumber,
        link_resource_number: this.detail.number,
        link_constraint: {
          password: Cookies.get(this.linkShareNumber),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享预览
    sharePreview() {
      let share_constraint, share_number;
      if (this.$route.name === "sharelink") {
        share_number = this.linkShareNumber;
        share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        share_number = this.shareNumber;
        share_constraint = null;
      }
      sharePreview({
        share_number: share_number,
        share_resource_number: this.detail.number,
        share_constraint: share_constraint,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 云盘预览
    preview() {
      preview({
        number: this.detail.number,
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },

  mounted() {
    $("#audio_preview").on("show.bs.modal", () => {
      if (this.$route.name === "sendlink") {
        this.sendPreview();
      } else if (
        (this.shareNumber && this.tab != "sharefile") ||
        this.$route.name === "sharelink"
      ) {
        this.sharePreview();
      } else {
        this.preview();
      }
    });
    $("#audio_preview").on("hide.bs.modal", () => {
      this.$refs.audio.pause();
    });
  },
  destroyed() {
    $("#audio_preview").off();
  },
};
</script>

<style scoped>
.modal-header {
  padding: 10px 15px;
  background: #f8f8f8;
}
.modal-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-body {
  padding: 0;
}
.audio {
  width: 100%;
  height: 58px;
  outline: none;
}
.iconfont {
  font-size: 14px;
}
</style>